<template>
  <div>
    <div class="con">
      <el-menu :default-active="active" mode="horizontal" :router="true" @select="handleSelect">
        <el-menu-item @click="clickLogo">
          <span
            style="width: 212px;
          height: 59px;
          font-size: 40px;
          float: left;
          cursor: pointer;"
          >澳新领域</span>
        </el-menu-item>
        <el-menu-item index="/index">
          <span class="navHover">首页</span>
        </el-menu-item>
        <el-menu-item index="/zkjg">
          <span class="navHover">重点机构</span>
        </el-menu-item>
        <el-menu-item index="/zhSearch">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.3451 15.2003C16.6377 15.4915 16.4752 15.772 16.1934 16.0632C16.15 16.1279 16.0958 16.1818 16.0525 16.2249C15.7707 16.473 15.4456 16.624 15.1854 16.3652L11.6848 12.8815C10.4709 13.8198 8.97529 14.3267 7.44714 14.3267C3.62134 14.3267 0.5 11.2314 0.5 7.41337C0.5 3.60616 3.6105 0.5 7.44714 0.5C11.2729 0.5 14.3943 3.59538 14.3943 7.41337C14.3943 8.98802 13.8524 10.5087 12.8661 11.7383L16.3451 15.2003ZM2.13647 7.4026C2.13647 10.3146 4.52083 12.6766 7.43624 12.6766C10.3517 12.6766 12.736 10.3146 12.736 7.4026C12.736 4.49058 10.3517 2.1286 7.43624 2.1286C4.50999 2.1286 2.13647 4.50136 2.13647 7.4026Z"
              fill="currentColor"
            />
          </svg>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="navi"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sort: [],
      active: "",
      userName: "admin"
    };
  },
  methods: {
    async handleCommand(command) {
      if (command == "center") {
        this.$router.push({
          path: "/center"
        });
      }
      this.active = "center";
      if (command == "quit") {
        this.$router.push({ name: "login" });
        const res = await userLogout();
        if (res.data.code == "ok") {
          this.$message("退出成功");
          removeUser();
          // console.log(111);
        }
        this.$router.push({ name: "login" });
      }
    },
    handleSelect(key, keyPath) {
      this.active = key;
    },
    handleSkipInd(p) {
      this.$router.push({
        name: "industry",
        query: {
          indCate: p
        }
      });
    },
    clickLogo() {
      this.$router.push("/index");
    }
  },
  async created() {
    // this.userName = getUserName();
    // this.active = "/" + this.$route.name;
    // const res = await getIndustrySort();
    // // console.log(res);
    // this.sort = res.data.data.industry_list;
  },
  watch: {
    $route(to, from) {
      this.active = to.path;
      // console.log(to);
    }
  },
  mounted() {
    // this.active = "/" + this.$route.name;
  }
};
</script>

<style lang="less">
.navi {
  height: 422px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 0;
  // background: #3F48CC;
  background: url(../../static/images/background22.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .el-dropdown-link.focusing {
    outline-color: transparent;
  }
  .el-icon-arrow-down {
    transition: all ease 0.5s;
  }
  .el-dropdown-selfdefine:hover {
    .el-icon-arrow-down {
      transform: rotate(180deg);
    }
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    color: #555;
  }
}

.navHover:hover {
  border-bottom: 1px solid;
}

.con {
  position: fixed;
  top: 0;
  // left: 25%;
  width: 100%;
  background: #fff;
  height: 70px;
  z-index: 99;
  margin: 0 auto;

  .el-dropdown {
    float: right;
    padding-top: 2.5rem;
    font-size: 12px;
    cursor: pointer;
  }

  .el-menu {
    margin-left: 70px;
    float: left;
    padding-top: 10px;
    /*padding-left: 40px;*/
    border: 0;

    .el-menu-item {
      font-size: 14px;
      height: 50px;
      margin: 0 38px;
      padding: 0 5px;
      font-weight: bold;
      color: #0c0c0c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navi.vue